





























import CommonBase from "../CommonBase";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {PersonmergeUndoInfo} from "../../modules/models";

@Component
export default class MergeUndoDialog extends CommonBase {
    @Inject()
    api!: Api;

    @Prop({default: false})
    value!: boolean;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }

    @Prop({default: null})
    personRef!: string | null;

    undoInfo: PersonmergeUndoInfo | null = null;
    loading = true;

    mergedCardNumsTxt() {
        if(this.undoInfo != null && this.undoInfo.mergedCardNums.length > 0) {
            return `(og kortnr ${this.undoInfo.mergedCardNums.join(", ")})`;
        }
        return "";
    }

    @Watch("value")
    async onValueChanged() {
        // load data when dialog is opened
        try {
            this.loading = true;
            if(this.personRef != null) {
                this.undoInfo = await this.api.fetchPersonmergeUndoInfo(this.personRef);
            } else {
                throw "no personRef set";
            }
        } finally {
            this.loading = false;
        }
    }

    async undo() {
        if(this.undoInfo != null) {
            this.$emit("at-undo-personmerge", this.undoInfo.txid);
        } else {
            throw new Error("undoInfo not found");
        }
    }
}
